import SEOSchema from '@/components/feature/SEOSchema';

const faqItems = [
  {
    question: '韩国漫画网上的韩漫都是免费的吗？',
    answer: '是的，韩国漫画网上的所有韩漫均为免费在线观看。我们致力于为中文读者提供免费、便捷的韩漫阅读服务。您无需支付任何费用，即可享受海量韩国漫画资源。所有漫画均支持下拉式免费阅读，为您带来流畅的阅读体验。',
  },
  {
    question: '韩漫在线免费看需要注册账号吗？',
    answer: '不需要。韩国漫画网目前无需注册即可自由浏览所有内容。您可以随意浏览韩漫免费漫画，享受在线观看和下拖式免费阅读的便利。我们会在未来推出账号系统，届时将为注册用户提供更多个性化服务。',
  },
  {
    question: '网站上的韩漫支持哪些阅读方式？',
    answer: '韩国漫画网全面支持下拉式免费阅读方式。您只需在漫画详情页面向下滑动，即可流畅地阅读漫画内容。我们也支持键盘翻页功能，为您提供与纸质漫画相似的阅读感受。所有韩漫在线阅读均适配桌面和移动端设备。',
  },
  {
    question: '韩国漫画网的漫画多久更新一次？',
    answer: '我们的编辑团队每天都会更新韩漫内容。连载中的韩国漫画通常按照原作者发布的频率同步更新，热门漫画几乎每日都有新章节。您可以关注"最新更新"板块，随时掌握最新的韩漫免费漫画更新动态。',
  },
  {
    question: '如何找到我想看的韩漫类型？',
    answer: '韩国漫画网提供了八大分类频道，包括恋爱、喜剧、奇幻、动作、悬疑、日常、剧情和恐怖。您可以通过顶部导航栏的"分类浏览"菜单，或在首页的分类导航区域点击感兴趣的类别，即可进入对应的分类页面浏览该类型下的所有韩国漫画。',
  },
  {
    question: '韩国漫画网的内容是否支持移动端阅读？',
    answer: '完全支持。韩国漫画网采用响应式设计，无论在电脑、平板还是手机上，都能获得优质的韩漫在线免费看体验。移动端的下拉式阅读经过专门优化，确保在小屏幕上也能流畅清晰地欣赏每一页韩国漫画。',
  },
];

export default function FAQSection() {
  const faqSchema = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-100" aria-label="常见问题">
      <SEOSchema type="FAQPage" data={faqSchema} />
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于韩漫在线免费看的常见疑问解答</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm font-medium text-foreground-800 pr-4">{item.question}</h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </div>
                <div className="w-5 h-5 items-center justify-center flex-shrink-0 text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}